module.exports = __webpack_public_path__ + "media/images/appstore-c1d4ae9833615b69b6694d66cd4e8ba0.png";